/**
 * A region (ADR-060's word, ADR-109 decision 7): the one notion OdysseyTales keeps of Daedalus's map group. The
 * Region chat scope, the Region banner and the music fallback read it from the compiled manifest's `group`, and
 * no second list of regions exists in the game.
 */

/**
 * The word the editor and the game use for a map group.
 */
export const REGION_LABEL = "Region";

/**
 * A region as the manifest names it: the group's id and its name.
 */
export interface Region {
  readonly id: string;
  readonly name: string;
}

/**
 * Reads a map's region from its manifest entry.
 *
 * @param map The manifest entry: only its optional `group` is read.
 * @returns The region, or undefined for a map with no group.
 */
export function regionOf(map: { readonly id?: string; readonly group?: Region }): Region | undefined {
  return map.group === undefined ? undefined : { id: map.group.id, name: map.group.name };
}
